// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Experiencia_secao__wx2qu {
  padding: 6rem 1.5rem;
  max-width: 900px;
  margin: 0 auto;
}

.Experiencia_etiqueta__yaErU {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  margin-bottom: 1rem;
  display: block;
}

.Experiencia_titulo__O8tBc {
  font-size: 2.5rem;
  font-weight: 800;
  color: hsl(210, 40%, 95%);
  margin-bottom: 3rem;
}

.Experiencia_lista__iARZT {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.Experiencia_item__r9t1g {
  position: relative;
  padding-left: 1.75rem;
  padding-bottom: 1.5rem;
  border-left: 2px solid hsl(222, 30%, 18%);
}

.Experiencia_item__r9t1g:last-child {
  padding-bottom: 0;
}

.Experiencia_ponto__Ecm3V {
  position: absolute;
  left: -6px;
  top: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: hsl(217, 91%, 60%);
  box-shadow: 0 0 12px hsl(217, 91%, 60%, 0.4);
}

.Experiencia_itemTitulo__AFVLs {
  font-size: 1.1rem;
  font-weight: 700;
  color: hsl(210, 40%, 92%);
  margin-bottom: 0.5rem;
}

.Experiencia_itemDescricao__YRD-t {
  color: hsl(215, 20%, 55%);
  font-size: 0.95rem;
  line-height: 1.7;
}
`, "",{"version":3,"sources":["webpack://./src/components/Experiencia/Experiencia.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".secao {\n  padding: 6rem 1.5rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.etiqueta {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.titulo {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: hsl(210, 40%, 95%);\n  margin-bottom: 3rem;\n}\n\n.lista {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.item {\n  position: relative;\n  padding-left: 1.75rem;\n  padding-bottom: 1.5rem;\n  border-left: 2px solid hsl(222, 30%, 18%);\n}\n\n.item:last-child {\n  padding-bottom: 0;\n}\n\n.ponto {\n  position: absolute;\n  left: -6px;\n  top: 6px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: hsl(217, 91%, 60%);\n  box-shadow: 0 0 12px hsl(217, 91%, 60%, 0.4);\n}\n\n.itemTitulo {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: hsl(210, 40%, 92%);\n  margin-bottom: 0.5rem;\n}\n\n.itemDescricao {\n  color: hsl(215, 20%, 55%);\n  font-size: 0.95rem;\n  line-height: 1.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secao": `Experiencia_secao__wx2qu`,
	"etiqueta": `Experiencia_etiqueta__yaErU`,
	"titulo": `Experiencia_titulo__O8tBc`,
	"lista": `Experiencia_lista__iARZT`,
	"item": `Experiencia_item__r9t1g`,
	"ponto": `Experiencia_ponto__Ecm3V`,
	"itemTitulo": `Experiencia_itemTitulo__AFVLs`,
	"itemDescricao": `Experiencia_itemDescricao__YRD-t`
};
export default ___CSS_LOADER_EXPORT___;
